import styled, { css } from 'styled-components';
export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

export const Label = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: var(--black-3);
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: transparent;
  border: 2px solid var(--gray-d);

  transition: 0.4s;
  border-radius: 34px;

  :before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: var(--gray-d);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  border-radius: 34px;
`;

export const InputElement = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  right: 0;

  :disabled {
    + span,
    + span:before {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
  :checked + span {
    border: 2px solid var(--info);
  }
  :checked + span:before {
    transform: translateX(26px);
    background-color: var(--info);
  }
`;

export const WarningText = styled.span`
  color: var(--danger);
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  animation: wiggle 0.8s;

  @keyframes wiggle {
    0% {
      transform: translateX(0px);
    }
    33% {
      transform: translateX(10px);
    }
    66% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0px);
    }
  }
`;
